<template>
  <div class="col-span-2 md:col-span-1">
    <strong class="block text-blue-dark text-2xs uppercase mb-4">
      {{ model.relatedFacetsTitle }}
    </strong>
    <div>
      <a
        v-for="(facet, index) in model.relatedFacets"
        :key="index"
        class="px-4 cursor-pointer py-1 ltr:mr-4 rtl:ml-4 mb-4 border border-gray-dark inline-flex whitespace-no-wrap items-center text-xs text-blue-dark bg-white rounded"
        :class="{
          'invisible absolute': index > 3 && !isOpened
        }"
        :href="facet.url"
        @click.prevent="onClick(facet)"
      >
        {{ facet.title }}
      </a>
    </div>
    <button
      v-if="model.relatedFacets.length > 4"
      class="text-blue-dark inline-flex items-center text-2xs"
      @click="toggleShowAll"
    >
      <template v-if="isOpened">
        <span class="underline">
          {{ model.seeLessText }}
        </span>
        <span class="transform rotate-180 icon-chevron-down text-3xs scale-75 ml-1 rtl:mr-1" />
      </template>
      <template v-else>
        <span class="underline">
          {{ model.seeMoreText }}
        </span>
        <span class="icon-chevron-down text-3xs transform scale-75 ml-1 rtl:mr-1" />
      </template>
    </button>
  </div>
</template>

<script>
import store from '@/components/facet/store'
import tracking from '@/helpers/tracking'
import pageRefresh from '@/components/facet/page-refresh'


export default {
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      store,
      isOpened: false
    }
  },
  methods: {
    async onClick(facet) {
      const { currentTagsAndTerms: currentFilters } = this.store.getters
      tracking.selectFilter({
        currentFilters,
        filterName: facet.title,
        placement: 'related filter block'
      })
      store.dispatch('showLoader')
      store.dispatch('setTags', { tags: facet.fullContentCriteriaTags })
      pageRefresh.updatePage()
    },
    toggleShowAll() {
      this.isOpened = !this.isOpened
    }
  }
}
</script>
